/**
 * Map Library Plugin
 *
 * Plugin-host–compatible plugin that loads the map provider SDK,
 * creates the map adapter, and exposes the facade on context.services.
 *
 * @module libraries/mapLibraryPlugin
 */

import createGoogleMapsAdapter from './googleMapsAdapter';

function createMapAdapter({ provider }) {
  if (provider === 'google') {
    return createGoogleMapsAdapter();
  }

  throw new Error('Unsupported map provider: ' + provider);
}

export default function createMapLibraryPlugin({ provider = 'google', config = {} } = {}) {
  let adapter = null;

  return {
    name: 'map-library',

    async init(context) {
      context.state.map = {
        provider,
        ready: false,
      };
    },

    async start(context) {
      if (context.services.mapFacade) {
        return;
      }

      adapter = createMapAdapter({ provider });
      await adapter.load({ config });

      context.services.mapFacade = adapter.createFacade();
      context.state.map = {
        provider,
        ready: true,
      };
    },

    async stop(context) {
      await adapter?.destroy?.();
      adapter = null;
      delete context.services.mapFacade;
      delete context.state.map;
    },
  };
}